import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconSlidersHorizontal",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], f = ["id"];
function p(e, i, l, _, v, t) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--sliders-horizontal"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Sliders Horizontal",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11 2a.5.5 0 0 0-.5-.5h-3V1a.5.5 0 1 0-1 0v2a.5.5 0 0 0 1 0v-.5h3A.5.5 0 0 0 11 2Zm-9.5-.5a.5.5 0 0 0 0 1H5a.5.5 0 1 0 0-1H1.5Zm4 4.5a.5.5 0 0 1 .5-.5h4.5a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5Zm-4-.5a.5.5 0 0 0 0 1h2V7a.5.5 0 0 0 1 0V5a.5.5 0 1 0-1 0v.5h-2Zm9 4a.5.5 0 1 1 0 1h-2v.5a.5.5 0 1 1-1 0V9a.5.5 0 0 1 1 0v.5h2Zm-9 0a.5.5 0 1 0 0 1H6a.5.5 0 1 0 0-1H1.5Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, h),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, f)
    ])
  ], 10, c);
}
const S = /* @__PURE__ */ u(m, [["render", p]]);
export {
  S as default
};
//# sourceMappingURL=sliders-horizontal.js.map
